const checkComapnyId = () => {
  const { pid: companyId, parentCompanyId } = window._currentCompanyInfo;
  return (
    (companyId === '56e6c0675d63551300f1b690' ||
      parentCompanyId === '56e6c0675d63551300f1b690' ||
      companyId === '56bfef41a17441a959d9c8da' ||
      parentCompanyId === '56bfef41a17441a959d9c8da') &&
    companyId !== '5ea82fdb315efb00085cae0f'
  );
};

export { checkComapnyId };
export default checkComapnyId;
